import { Text } from '../../Atoms/Text';
import { Toggle } from '../../Atoms/Toggle';

export interface LabelledToggleProps {
  id: string;
  dataTestId: string;
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const LabelledToggle = ({ id, dataTestId, label, checked, onChange }: LabelledToggleProps) => (
  // The switch renders a hidden input, so it only takes a click from inside the label.
  <label
    className="flex items-center gap-2 cursor-pointer"
    htmlFor={id}>
    <Text
      color="grey4"
      size="sm14"
      isSpan>
      {label}
    </Text>
    <Toggle
      id={id}
      dataTestId={dataTestId}
      checked={checked}
      onChange={(event) => onChange(event.target.checked)}
    />
  </label>
);
